
import { DomainsKeys } from '../../external-configuration';

import Call, { buildApiBasePath } from './Base';

export function loadConfiguration( iframeId) {
  const uri = `${buildApiBasePath(DomainsKeys.Configuration)}/public/iframe/${iframeId}`;
  const options = {
    uri,
  };

  return Call.get( uri, options);
}
